var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeacher(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 56,
    viewBox: "0 0 70 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_236_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 0V4H57.0095V44H23.0769V48H66V44H61V0H4ZM13.5432 7.2C11.0157 7.20885 8.59421 8.22296 6.80654 10.0213C5.01888 11.8196 4.01005 14.2562 4 16.8C4 22.0776 8.30185 26.4 13.5432 26.4C16.0695 26.3899 18.4893 25.3751 20.2751 23.5768C22.061 21.7785 23.0681 19.3425 23.0769 16.8C23.0769 11.5272 18.7798 7.2 13.5432 7.2ZM27.8462 11V14.4H39.7692V11H27.8462ZM44.5385 11V14.4H51.6923V11H44.5385ZM13.5 10.5989C16.8077 10.5989 20 13.2188 20 16.7188C20 20.2188 17.5 23.2188 13.5432 23.2188C9.58646 23.2188 7 20.7188 7 16.7188C7 12.7188 10.1923 10.5989 13.5 10.5989ZM27.8509 20.5L27.8462 23.5768H51.6923V20.5H41.5H27.8509ZM4 28.8V48H6.80654V32.3773H17.1249V48H20.6923V33.6227L25.1183 36.4808C26.5133 37.2248 27.9921 37.2224 29.3847 36.4808L37.8024 32L36.271 29.076L27.3828 33.9216L20.2751 29.7636C19 29 18.2902 28.8007 17.1249 28.8H4Z",
    fill: "#3C789E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_236_18",
    x: 0,
    y: 0,
    width: 70,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_236_18"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_236_18",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacher);
export default __webpack_public_path__ + "static/media/Teacher.3cb9b871536e61b91b6c786879795da7.svg";
export { ForwardRef as ReactComponent };